import { z } from 'zod';

export const MemoryItemView = z.object({
  id: z.string(),
  npcId: z.string().nullable(),
  kind: z.enum(['preference', 'fact', 'statement', 'commitment']),
  text: z.string(),
  sourceLabel: z.string(),
  createdAt: z.string(),
  deletable: z.boolean(),
});
export type MemoryItemView = z.infer<typeof MemoryItemView>;

export const DataRequestView = z.object({
  id: z.string(),
  kind: z.enum(['export', 'delete']),
  status: z.enum(['queued', 'running', 'completed', 'failed', 'cancelled']),
  downloadUrl: z.string().nullable(),
  createdAt: z.string(),
  scheduledFor: z.string().nullable(),
});
export type DataRequestView = z.infer<typeof DataRequestView>;

export const DeleteAccountRequest = z.object({ confirm: z.literal('DELETE') });
export const PushTokenRequest = z.object({
  deviceId: z.string().min(8).max(100),
  token: z.string().min(10).max(300),
  platform: z.enum(['ios', 'android']),
});
export type PushTokenRequest = z.infer<typeof PushTokenRequest>;
export type DeleteAccountRequest = z.infer<typeof DeleteAccountRequest>;
